<template>
	<section id="contact" class="footer">
		<div class="container">
			<div class="columns">
				<div class="column">
					<img class="footer-logo" src="../assets/logo-light.png">
					<p class="has-text-light" style="margin-top:20px">Makurdi, Benue, Nigeria</p>
					<p class="has-text-light">Phone: +234 7038550575, +234 8065335014</p>
					<p class="has-text-light">Email: info@clustab.com</p>
					<small class="has-text-grey-lighter" style="display:block;margin-top:20px">
						&copy; Clustab Distributors Ltd. - RC 1486008
					</small>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'Footer'
}
</script>

<style>
.footer {
	background-color: #3F3D56;
	background-image: url('../assets/banner_top_bg.png');
	background-repeat: no-repeat;
	color: #fff
}
.footer-logo {
	max-width: 150px;
}
</style>
